import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonTemplatesService } from 'app/services/common-templates.service';

@Component({
  selector: 'app-common-template-refs',
  templateUrl: './common-template-refs.component.html',
  styleUrls: ['./common-template-refs.component.css']
})
export class CommonTemplateRefsComponent implements OnInit, AfterViewInit {
	@ViewChild('nguidCellTempl', { static: false }) nguidCellTempl: TemplateRef<any>;
	@ViewChild('globalIdCellTempl', { static: false }) globalIdCellTempl: TemplateRef<any>;
	@ViewChild('qaErrorLevelCellTempl', { static: false }) qaErrLevelCellTempl: TemplateRef<any>;

	qaErrorLevelColName: string
	constructor(
		private attrIndexService: AttrIndexService,
		private commonTemplateService: CommonTemplatesService
	) { }

	ngOnInit() {
		this.qaErrorLevelColName = this.attrIndexService.qaErrorLevelColName;
	}
	ngAfterViewInit(): void {
		this.commonTemplateService.nguidCellTemplate = this.nguidCellTempl;		
		this.commonTemplateService.globalIdCellTempl = this.globalIdCellTempl;	
		this.commonTemplateService.qaErrorLevelCellTempl = this.qaErrLevelCellTempl;	
	}

}
